<template>
  <div class="modal">
    <div class="modal-inner">
      <div class="modal-content">
        <div class="pdf-container">
          <canvas ref="pdfCanvas"></canvas>
        </div>
      </div>
      <div class="controls" >
        <button @click="prevPage" :disabled="pageNum <= 1">{{$t('cgu.previous')}}</button>
        <span> Page {{ pageNum }} of {{ numPages }} </span>
        <button @click="nextPage" :disabled="pageNum >= numPages">{{$t('cgu.next')}}</button>
      </div>

      <div class="controls" >
        <b-button @click="accepteCGA">
          {{$t('cgu.accepter')}}
        </b-button>
        <b-button @click="refuserCGA">
          {{$t('cgu.refuser')}}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import pdfjsLib from 'pdfjs-dist'

export default {
  data () {
    return {
      pdf: null,
      pageNum: 1,
      numPages: 0,
      pdfUrl: '', // URL of the PDF to load
    }
  },
  props: {
    documentUrl: String,
  },
  computed: {
    ...mapState(['user']),
  },
  mounted () {
    const pdfUrl = this.documentUrl
    this.open(pdfUrl) // Open modal and load the PDF
  },
  methods: {
    accepteCGA () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: true
      })

      this.$emit('close-modal')
    },
    refuserCGA () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: false
      })

      this.$emit('close-modal')
    },
    open (pdfUrl) {
      this.pdfUrl = pdfUrl
      this.isVisible = true
      this.loadPdf(pdfUrl)
    },
    close () {
      this.isVisible = false
    },
    loadPdf (url) {
      // Load the PDF document from the URL
      pdfjsLib.getDocument(url).promise.then(
        (pdfDoc_) => {
          this.pdf = pdfDoc_
          this.numPages = pdfDoc_.numPages
          this.renderPage(this.pageNum)
        },
        (error) => {
          console.error('Error loading PDF: ', error)
        }
      )
    },
    renderPage (num) {
      this.pdf.getPage(num).then((page) => {
        const canvas = this.$refs.pdfCanvas
        const context = canvas.getContext('2d')
        const viewport = page.getViewport({ scale: 1.5 }) // Adjust scale for zoom

        // Set the canvas dimensions to match the PDF page
        canvas.height = viewport.height
        canvas.width = viewport.width

        // Render the page to the canvas context
        page.render({ canvasContext: context, viewport: viewport })
      })
    },
    nextPage () {
      if (this.pageNum < this.numPages) {
        this.pageNum++
        this.renderPage(this.pageNum)
      }
    },
    prevPage () {
      if (this.pageNum > 1) {
        this.pageNum--
        this.renderPage(this.pageNum)
      }
    },
  }
}
</script>

<style scoped>
.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.modal .modal-content {
    width: 100%;
    max-height: calc(100vh - 100px);
}
.modal {
  position: fixed;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.modal-inner {
  background-color: white;
  border-radius: 0.5em;
  margin: auto;
}
.controls{
  padding: 2px;
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
</style>
